<template>
  <scroll></scroll>
  <router-view></router-view>
</template>
